export default __webpack_public_path__ + "images/0xf655c8567e0f213e6c634cd2a68d992152161dc6.png";